{
  "familyId": "SPR-KLANK-JAGER",
  "questions": [
    {
      "id": "SPR-KLANK-JAGER-CAT-001",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "categorize",
      "question": "Sorteer de woorden: welke hebben een open lettergreep (ja-ger) en welke een gesloten lettergreep (bak-ker)?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Open (ja-ger)", "Gesloten (bak-ker)"],
        "items": [
          { "text": "lopen", "correctCategory": 0 },
          { "text": "happen", "correctCategory": 1 },
          { "text": "maken", "correctCategory": 0 },
          { "text": "zitten", "correctCategory": 1 },
          { "text": "komen", "correctCategory": 0 },
          { "text": "rennen", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open vs. gesloten lettergreep",
            "content": "Open lettergreep: eindigt op een klinker (lo-pen, ma-ken). Gesloten lettergreep: eindigt op een medeklinker (hap-pen, zit-ten). Bij open lettergrepen schrijf je één medeklinker, bij gesloten twee.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_closed_syllable_categorize",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Open lettergrepen eindigen op een klinker (lo-pen, ma-ken, ko-men). Gesloten lettergrepen eindigen op een medeklinker (hap-pen, zit-ten, ren-nen). Bij open lettergrepen schrijf je één medeklinker tussen de klinkers, bij gesloten twee.",
        "solutionSteps": [
          "Verdeel het woord in lettergrepen",
          "Eindigt de eerste lettergreep op een klinker? → open (ja-ger type)",
          "Eindigt de eerste lettergreep op een medeklinker? → gesloten (bak-ker type)",
          "Open: lopen, maken, komen. Gesloten: happen, zitten, rennen"
        ]
      }
    },
    {
      "id": "SPR-KLANK-JAGER-CAT-002",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "categorize",
      "question": "Sorteer de woorden bij de juiste spellingregel.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Eén medeklinker (open)", "Twee medeklinkers (gesloten)"],
        "items": [
          { "text": "slapen", "correctCategory": 0 },
          { "text": "stoppen", "correctCategory": 1 },
          { "text": "wonen", "correctCategory": 0 },
          { "text": "kussen", "correctCategory": 1 },
          { "text": "roken", "correctCategory": 0 },
          { "text": "vallen", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "syllableBlocks",
          "showWhen": "wrong",
          "data": {
            "word": "slapen",
            "syllables": ["sla", "pen"],
            "highlight": [0],
            "label": "Open lettergreep: 'sla' eindigt op 'a' (klinker) → één p"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdubbelen of niet?",
            "content": "Als de eerste lettergreep open is (eindigt op klinker), schrijf je één medeklinker: sla-pen, wo-nen. Als de eerste lettergreep gesloten is (eindigt op medeklinker), verdubbel je: stop-pen, val-len.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "doubling_consonant_categorize",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij open lettergrepen (sla-pen, wo-nen, ro-ken) schrijf je één medeklinker. Bij gesloten lettergrepen (stop-pen, kus-sen, val-len) verdubbel je de medeklinker om de korte klank te behouden.",
        "solutionSteps": [
          "Verdeel in lettergrepen en luister naar de klinker",
          "Lange klinker (aa, ee, oo geluid) → open → één medeklinker",
          "Korte klinker → gesloten → twee medeklinkers",
          "Eén: slapen, wonen, roken. Twee: stoppen, kussen, vallen"
        ]
      }
    }
  ]
}